// Returns persisted expiryDate or derives it for older subscription records.
export const getSubscriptionExpiryDate = (subscription) => {
  if (!subscription) return null;
  if (subscription.expiryDate) return subscription.expiryDate;

  const durationMonths = Number(subscription.plan?.durationMonths);
  if (!subscription.startDate || !Number.isFinite(durationMonths) || durationMonths <= 0) return null;

  const start = Array.isArray(subscription.startDate)
    ? new Date(subscription.startDate[0], subscription.startDate[1] - 1, subscription.startDate[2])
    : new Date(`${subscription.startDate}T00:00:00`);
  if (Number.isNaN(start.getTime())) return null;

  start.setMonth(start.getMonth() + durationMonths);
  return start.toISOString().slice(0, 10);
};

export const getSubscriptionExpiryDateObject = (subscription) => {
  const expiry = getSubscriptionExpiryDate(subscription);
  return expiry ? new Date(`${expiry}T23:59:59`) : null;
};
